import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'

// models
import { FilterTaskSheet } from '@/models/taskSheet'

@Module({ namespaced: true })
class TaskSheetModule extends VuexModule {
	public filtersState: FilterTaskSheet = {
    dateStart: null,
    dateEnd: null,
    workType: null,
    headquarter: null,
    area: null,
    subarea: null,
		employee_id: null
  }

  public showFiltersState = false

	get filters () {
		return this.filtersState
	}

  get showFilters () {
    return this.showFiltersState
  }

	@Mutation
	public SET_FILTER (payload: FilterTaskSheet): void {
    this.filtersState = payload
	}

  @Mutation
	public SET_SHOW_FILTER (payload: boolean): void {
    this.showFiltersState = payload
	}

	@Action
	public async changeFilters (payload: FilterTaskSheet) {
		this.context.commit('SET_FILTER', payload)
	}

  @Action
	public async changeShowFilters (payload: boolean) {
		this.context.commit('SET_SHOW_FILTER', payload)
	}
}

export default TaskSheetModule
